import React from "react";
import {
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { PostCallViewProps } from "../postCall.types";
import ThanksIllustration from "../../../assets/ThanksIllustration";

export default function PostCallViewDesktop({
  onScheduleAnother,
  onNoThanks,
}: PostCallViewProps) {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <ThanksIllustration
          width={312.1797180175781}
          height={331.959716796875}
          style={styles.illustration}
        />

        <Text style={styles.title}>Nice job showing up!</Text>
        <Text style={styles.subtitle}>
          Every conversation is a step forward.
        </Text>

        <Text style={styles.prompt}>
          You can start the next one whenever you feel ready:
        </Text>

        <View style={styles.actions}>
          <View style={styles.actionGroup}>
            <TouchableOpacity
              style={[styles.actionButton, styles.skipButton]}
              onPress={onNoThanks}
              activeOpacity={0.85}
            >
              <Ionicons name="close" size={48.15722192362697} color="#fff" />
            </TouchableOpacity>
            <Text style={styles.actionLabel}>Skip</Text>
          </View>
          <View style={styles.actionGroup}>
            <TouchableOpacity
              style={[styles.actionButton, styles.newButton]}
              onPress={onScheduleAnother}
              activeOpacity={0.85}
            >
              <Ionicons name="add" size={48.15722192362697} color="#fff" />
            </TouchableOpacity>
            <Text style={styles.actionLabel}>New</Text>
          </View>
        </View>
      </View>

      <View style={styles.bottomFooter}>
        <Text style={styles.copyright}>© Copyright KNEXO 2025</Text>
        <TouchableOpacity style={styles.feedbackButton}>
          <Ionicons name="chatbubble-outline" size={14} color="#1e88e5" />
          <Text style={styles.feedbackText}>FEEDBACK</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#232335",
  },
  header: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingTop: 18,
    paddingBottom: 8,
  },
  logo: {
    width: 120,
    height: 36,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
    paddingBottom: 24,
  },
  illustration: {
    width: 312.1797180175781,
    height: 331.959716796875,
    marginBottom: 16,
  },
  title: {
    fontFamily: "Lexend",
    fontSize: 44,
    fontWeight: "700",
    lineHeight: 25,
    color: "#f5f6ff",
    textAlign: "center",
    marginBottom: 22,
  },
  subtitle: {
    fontFamily: "Lexend",
    fontSize: 22,
    fontWeight: "400",
    color: "#c9cbdd",
    textAlign: "center",
    lineHeight: 30,
    marginBottom: 66,
  },
  prompt: {
    fontFamily: "Lexend",
    fontSize: 22,
    fontWeight: "400",
    color: "#c9cbdd",
    textAlign: "center",
    lineHeight: 30,
    marginBottom: 18,
  },
  actions: {
    flexDirection: "row",
    gap: 50,
  },
  actionGroup: {
    alignItems: "center",
  },
  actionButton: {
    width: 98,
    height: 98,
    borderRadius: 1000,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  skipButton: {
    backgroundColor: "#e95b5b",
  },
  newButton: {
    backgroundColor: "#3f73c7",
  },
  actionLabel: {
    fontFamily: "Lexend",
    fontSize: 20,
    fontWeight: "700",
    lineHeight: 30,
    color: "#f5f6ff",
  },
  bottomFooter: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: "transparent",
    position: "relative",
  },
  copyright: {
    fontSize: 11,
    color: "#9aa0a6",
  },
  feedbackButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 16,
    backgroundColor: "#eaf2ff",
    borderWidth: 1,
    borderColor: "#9cc0ef",
    position: "absolute",
    right: 24,
    bottom: 6,
  },
  feedbackText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#1e88e5",
  },
});
